import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Star, Map, Sparkles } from 'lucide-react';

interface WelcomeBannerProps {
  userId: string;
  userName: string;
}

export function WelcomeBanner({ userId, userName }: WelcomeBannerProps) {
  const navigate   = useNavigate();
  const storageKey = `professya_welcome_free_${userId}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(storageKey) === '1');

  if (dismissed) return null;

  function dismiss() {
    localStorage.setItem(storageKey, '1');
    setDismissed(true);
  }

  const firstName = userName?.split(' ')[0] ?? 'você';

  return (
    <div className="card" style={{
      marginBottom: '1.75rem',
      background: 'linear-gradient(135deg, rgba(201,168,76,0.08) 0%, rgba(13,17,48,0.04) 100%)',
      border: '1px solid rgba(201,168,76,0.3)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <div>
          <p style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--petrol)', margin: '0 0 0.3rem' }}>
            Bem-vinda à Professya
          </p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: '1.25rem', fontWeight: 400, color: 'var(--bg)', margin: '0 0 0.25rem' }}>
            {firstName}, seu mapa astral te espera ✦
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-caption)', margin: 0, lineHeight: 1.5 }}>
            Gere seu mapa natal grátis e descubra o que os astros revelam sobre você.
          </p>
        </div>
        <button
          className="btn btn-ghost btn-icon"
          onClick={dismiss}
          aria-label="Fechar"
          style={{ flexShrink: 0, marginLeft: '0.5rem' }}
        >
          <X size={16} />
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
        {[
          { icon: <Map size={18} />, label: 'Mapa Astral', sub: 'Grátis', to: '/birth-chart' },
          { icon: <Star size={18} />, label: 'Previsões', sub: 'Personalizadas', to: '/forecast' },
          { icon: <Sparkles size={18} />, label: 'Tarô', sub: '16 sistemas', to: '/tarot' },
        ].map(item => (
          <button
            key={item.to}
            onClick={() => { dismiss(); navigate(item.to); }}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.3rem',
              padding: '0.75rem 0.5rem',
              backgroundColor: 'var(--bg-elevated)',
              border: '1px solid var(--line-soft)',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              color: 'inherit',
            }}
          >
            <span style={{ color: 'var(--petrol)' }}>{item.icon}</span>
            <span style={{ fontSize: '0.7rem', fontWeight: 600, color: 'var(--text-primary)', lineHeight: 1.2 }}>{item.label}</span>
            <span style={{ fontSize: '0.6rem', color: 'var(--text-muted)', lineHeight: 1.2 }}>{item.sub}</span>
          </button>
        ))}
      </div>

      <button
        className="btn btn-primary"
        onClick={() => { dismiss(); navigate('/birth-chart'); }}
        style={{ width: '100%' }}
      >
        ✦ Gerar Meu Mapa Astral Grátis
      </button>
    </div>
  );
}
